import BrowserDetector from './browser-detector';
import Device from '../interfaces/Device';

const deviceDetails = (ua = window.navigator.userAgent) : Device => {
  const agent = new BrowserDetector(ua);
  const browser = agent.parseUserAgent();
  const details = {
    os: {
      name: browser.platform,
    },
    browser: {
      name: browser.name,
      version: browser.version,
    },
  };
  return details;
};

export default deviceDetails;
